module.exports = __webpack_public_path__ + "static/media/img3-1.cabe16ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/agave/nutricheck_foliar/K/img3-1.png
// module id = 1047
// module chunks = 3